"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslate = void 0;
var _i18n = require("@c3po/i18n");
const useTranslate = () => {
  const translation = (0, _i18n.useTranslate)();
  if (!translation) return {
    i18n: x => x
  };
  return translation;
};
exports.useTranslate = useTranslate;